import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Images/logo.png';
import { FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { LuMoveUp } from 'react-icons/lu';
import { FaFacebook, FaXTwitter } from 'react-icons/fa6';

function Footer() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <footer className="bg-[#1a1a1a] text-white pt-8">
            <div className="container mx-auto px-4 max-w-screen-xl">
                <div className="border-t border-gray-700 pt-6">
                    {/* Top Section */}
                    <div className="flex flex-col md:flex-row justify-between items-center md:items-start space-y-6 md:space-y-0">
                        {/* Logo Section */}
                        <div>
                            <Link to='/'>
                                <img src={logo} alt="logo" className="h-12 md:h-14 w-auto" />
                            </Link>
                        </div>

                        {/* Social Links */}
                        <div className="flex space-x-6">
                            <a href="https://www.instagram.com/architetivedesigns?igsh=MTV4eGIyeTlreGZ0cQ==" target='blank' className="text-gray-400 hover:text-white">
                                <FaInstagram className="text-xl md:text-2xl" />
                            </a>
                            <a href="https://www.facebook.com/share/1Aqcj3DFFa/" target='blank' className="text-gray-400 hover:text-white">
                                <FaFacebook className="text-xl md:text-2xl" />
                            </a>
                            <a href="https://www.linkedin.com/in/architetive-designs-18279934a" target='blank' className="text-gray-400 hover:text-white">
                                <FaLinkedin className="text-xl md:text-2xl" />
                            </a>
                            <a href="https://www.youtube.com/channel/UC7a1glo22K08gE_GGxP3oqQ" target='blank' className="text-gray-400 hover:text-white">
                                <FaYoutube className="text-xl md:text-2xl" />
                            </a>
                            <a href="https://x.com/ArchitetiveD" target='blank' className="text-gray-400 hover:text-white">
                                <FaXTwitter className="text-xl md:text-2xl" />
                            </a>
                        </div>

                        {/* Back to Top Button */}
                        <div>
                            <button
                                onClick={scrollToTop}
                                className="gap-2 px-4 py-2 flex items-center justify-center bg-gray-100/15 text-white rounded-full shadow-lg transform hover:bg-gray-100/30 transition duration-200"
                            >
                                <LuMoveUp className="text-lg" />
                                Back To Top
                            </button>
                        </div>
                    </div>

                    {/* Links and Policies Section */}
                    <div className="flex flex-col md:flex-row justify-between items-center mt-8 space-y-4 md:space-y-0">
                        {/* Links */}
                        <div className="flex flex-wrap justify-center md:justify-start space-x-6 text-sm">
                            <Link to="/projects" className="hover:text-gray-400">Projects</Link>
                            <Link to="/expertise" className="hover:text-gray-400">Expertise</Link>
                            <Link to="/studio" className="hover:text-gray-400">Studio</Link>
                            <Link to="/careers" className="hover:text-gray-400">Careers</Link>
                            <Link to="/contact" className="hover:text-gray-400">Contact</Link>
                        </div>

                        {/* Policies and Attribution */}
                        <div className="flex flex-col text-sm text-center md:text-right space-y-2">
                            <div className="text-gray-500 text-xs">
                                All images sourced from <a href="https://www.pexels.com" className="hover:text-gray-300 underline" target="_blank" rel="noopener noreferrer">Pexels</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-gray-400 pt-5 pb-2 flex items-center justify-center">
                © 2025 Architetive Designs. All Rights Reserved.
            </div>
        </footer>
    );
}

export default Footer;